import React from 'react'
import {
    Collection,
    Feature,
    Header,
    Products,
  } from "../components";

const Home = () => {
  return (
    <>
    <Header/>
    <Feature/>
    <Collection/>
    <Products/>
    </>
  )
}

export default Home